import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment, a as Host } from './index.js';
import { C as CELL_CLASS_MENU, g as getColumnStyle, a as CELL_CLASS } from './p-Cma-DzNY.js';
import { d as defineCustomElement$a } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$9 } from './p-BedvZv52.js';
import { d as defineCustomElement$8 } from './p-BN9xIVU9.js';
import { d as defineCustomElement$7 } from './p-DZKBv4tL.js';
import { d as defineCustomElement$6 } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$5 } from './p-BVCTlSQE.js';
import { d as defineCustomElement$4 } from './p-DaiIyqo3.js';
import { d as defineCustomElement$3 } from './p-aqq22Qbe.js';
import { d as defineCustomElement$2 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$1 } from './p-QtR5VUMp.js';

const tableHeaderRowCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:block;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;min-width:100%;width:0}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.container{background-color:var(--jw-theme-surface-tile-bg-color);position:relative}.state-container{display:none;height:100%;top:0;width:100%}.state,.state-container{bottom:0;left:0;pointer-events:none;position:absolute;right:0}.state{align-items:center;display:flex;justify-content:center;opacity:0;text-align:center;top:42px;transition:opacity .3s ease;z-index:1}.state p{max-width:50ch;white-space:pre-line}.state-title{font-size:15px!important}.state-description{font-size:13px!important;margin:0!important}:host([selectable]) wui-skeleton-line{left:32px}:host([error-type=error]) wui-table-row,:host([is-empty]) wui-table-row{opacity:.1;pointer-events:none}:host([error-type=error]) .state-container,:host([is-empty]) .state-container{display:block}:host([error-type=error]) wui-table-row:not(:nth-child(n+1):nth-child(-n+11)),:host([is-empty]) wui-table-row:not(:nth-child(n+1):nth-child(-n+11)){display:none}:host([error-type=error]) .state.error{opacity:1;pointer-events:all}:host([is-empty]:not([error-type=error])) wui-table-header-row{opacity:.1}:host([is-empty]:not([error-type=error])) .state.empty{opacity:1;pointer-events:all}:host([loading]) .cell{opacity:0}:host{display:flex;flex-direction:row;flex-wrap:wrap;position:relative}:host:after{background-color:var(--jw-theme-surface-border-border-color);bottom:0;content:\"\";height:1px;left:0;position:absolute;right:0;width:100%}.cell{align-items:center;color:var(--jw-theme-surface-text-default-color);display:flex;flex:1 1 0;height:100%;margin:0 .5rem;min-width:0}.cell.checkbox{display:flex;flex-grow:0;justify-content:center;line-height:0;margin:0;max-width:32px;min-width:32px}.cell.checkbox wui-check-input[checked],.cell.checkbox wui-check-input[indeterminate]{opacity:1!important}.cell[data-sort-type=number]{justify-content:flex-end}.cell__menu{align-items:center;display:inline-flex;margin:0 .5rem;padding:0;width:2rem}:host{height:42px}.cell[data-sort-type=number] button{flex-direction:row-reverse}button{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background:none;border:none;box-sizing:border-box;color:var(--jw-theme-surface-text-description-color);cursor:pointer;display:inline-flex;display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;font-weight:inherit;gap:.25rem;height:100%;justify-content:center;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;margin:0;max-width:100%;padding:0;-webkit-user-select:none;user-select:none}button *,button :after,button :before{box-sizing:inherit}button img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}button[disabled]{cursor:not-allowed}button:focus{outline:none}button span{font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}button wui-icon{height:1rem;width:1rem;stroke:currentColor}.checkbox{margin:0 .5rem}.checkbox,.selection-overlay{align-items:center;display:flex}.selection-overlay{height:100%;justify-content:flex-end;position:absolute;right:0;z-index:1}.selection-overlay hr{border-color:var(--jw-theme-surface-divider-color);border-style:solid;border-width:1px;border-bottom:0;border-left:0;flex:none;margin:0;padding:0}:host([rows-selected]) .cell{opacity:0}";

const WuiTableHeaderRow = /*@__PURE__*/ proxyCustomElement(class WuiTableHeaderRow extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.sort = createEvent(this, "sort", 3);
        this.selectAllRows = createEvent(this, "selectAllRows", 3);
        this.disableAll = createEvent(this, "disableAll", 3);
        this.sortable = false;
        this.selectionStatus = 'none';
        this.selectedKeysLength = 0;
        this.disabled = false;
    }
    renderSelectionOverlay() {
        const selectedRecords = this.tableDataSource?.getSelectedRecords();
        if (typeof selectedRecords === 'undefined' || selectedRecords.length === 0) {
            return;
        }
        const children = this.selectionActionButtons?.(selectedRecords);
        const deleteButton = children?.find((child) => child && child.props.type === 'delete');
        const childrenWithoutDelete = children?.filter((btn) => btn !== deleteButton);
        const getOnClickHandler = (btnProps) => async (evt) => {
            const btn = evt.currentTarget;
            try {
                if (btnProps.autoDisableInteractionOnClick) {
                    if (btn) {
                        btn.loading = true;
                    }
                    this.disableAll.emit(true);
                }
                // Fire onclick event handler from props
                await btnProps.onClick?.(evt);
            }
            finally {
                if (btnProps.autoDisableInteractionOnClick) {
                    if (btn) {
                        btn.loading = false;
                    }
                    this.disableAll.emit(false);
                }
            }
        };
        return (h("div", { class: "selection-overlay" }, h("wui-layout", { type: "button-group" }, childrenWithoutDelete?.map((child, idx) => {
            if (!child) {
                return;
            }
            return (h("wui-button", { key: idx, ...child.props, disabled: this.disabled || ('disabled' in child.props && child.props.disabled), onClick: getOnClickHandler(child.props), type: "tertiary" }));
        }), deleteButton && (h(Fragment, null, childrenWithoutDelete && childrenWithoutDelete.length > 0 ? h("hr", null) : null, h("wui-button", { label: "Delete", icon: "trash", intent: "error", type: "tertiary", disabled: this.disabled, onClick: getOnClickHandler(deleteButton.props) }))))));
    }
    render() {
        const isSelectable = typeof this.selectable !== 'undefined' && this.selectable !== false;
        return (h(Host, { key: '06097fbbc07bf6c02b2bbb37f063aac135f408c6' }, isSelectable && (h("div", { key: '2822f768fd49bc10b3ab5c8c24f76051aefd38ba', class: "checkbox" }, h("wui-check-input", { key: '9655e4bc30d5680cd64cd2b10d4c5bd617711ae6', disabled: this.disabled || this.selectable === 'single', checked: this.selectionStatus === 'all', indeterminate: this.selectionStatus === 'some', onInput: (e) => {
                this.selectAllRows.emit(e.target.checked);
            }, label: this.selectedKeysLength ? `${this.selectedKeysLength} selected` : '' }))), this.visibleColumns?.map((column) => {
            let sortIcon;
            // Always first check if parent allows sorting
            const columnIsSortable = this.sortable && (typeof column.sortable === 'undefined' ? true : column.sortable);
            if (columnIsSortable) {
                // If current sorting column
                if (column.name === this.sortField) {
                    // Sort icon is chevron
                    sortIcon = this.sortOrder === 'asc' ? 'chevron-up' : 'chevron-down';
                }
                else {
                    // Default sort icon
                    sortIcon = 'selector';
                }
            }
            return (h("div", { key: String(column.name), "data-col": String(column.name).replace(/\./gm, '-'), "data-sort-type": column.sortType, class: CELL_CLASS, style: getColumnStyle(column) }, h("button", { type: "button", onClick: () => {
                    if (!columnIsSortable) {
                        return;
                    }
                    this.sort.emit(column.name);
                }, disabled: this.disabled || !columnIsSortable, title: column.label }, h("span", null, column.label), sortIcon && h("wui-icon", { name: sortIcon, size: "sm" }))));
        }), this.rowMenuItems ? h("div", { class: CELL_CLASS_MENU }) : null, this.renderSelectionOverlay()));
    }
    static get style() { return tableHeaderRowCss; }
}, [257, "wui-table-header-row", {
        "visibleColumns": [16, "visible-columns"],
        "sortField": [1, "sort-field"],
        "sortable": [4],
        "sortOrder": [1, "sort-order"],
        "selectable": [520],
        "selectionStatus": [1, "selection-status"],
        "selectedKeysLength": [2, "selected-keys-length"],
        "disabled": [516],
        "selectionActionButtons": [16, "selection-action-buttons"],
        "tableDataSource": [16, "table-data-source"],
        "rowsSelected": [516, "rows-selected"],
        "rowMenuItems": [4, "row-menu-items"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-table-header-row", "wui-box", "wui-button", "wui-check-input", "wui-form-field", "wui-icon", "wui-layout", "wui-loader", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-table-header-row":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTableHeaderRow);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiTableHeaderRow as W, defineCustomElement as d };
